import { cn } from '@/lib/cn';
import { initials } from '@/lib/format';
import { hueClass, hueFor, type Hue } from '@/lib/hue';

/** Initials on a tint. A person keeps the same hue everywhere; the signed-in person is purple. */
export function Avatar({
  name,
  size = 'md',
  inverted = false,
  hue,
  className,
}: {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  /** The signed-in person. */
  inverted?: boolean;
  hue?: Hue;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'grid shrink-0 place-items-center rounded-full leading-none font-semibold tinted select-none',
        hueClass(hue ?? (inverted ? 'purple' : hueFor(name))),
        size === 'sm' && 'size-5 text-3xs',
        size === 'md' && 'size-7 text-2xs',
        size === 'lg' && 'size-10 text-lg',
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
